module.exports = "<p>\r\n  my-page works!\r\n</p>\r\n"